import React, { CSSProperties } from 'react';

/** Type of logo to display. */
export enum eLogo {
  /** Standard logo. */
  standard = 0,
  /** Monochrome logo. */
  mono = 1,
  /** Icon logo. */
  icon = 2
}

export interface LogoProps {
  width?: number;
  height?: number;
  logo?: eLogo;
  style?: CSSProperties;
  className?: string;
}

const LOGO_SRC: { [logo in eLogo]: string } = {
  [eLogo.standard]: '/public/observodon-logo.svg',
  [eLogo.mono]: '/public/obd_logo_gold_h60.png',
  [eLogo.icon]: '/public/obd_icon_ruby.png'
};

const Logo = (props: LogoProps) => {
  const { width, height, style, className } = props;
  return (
    <>
      <img
        src={LOGO_SRC[props.logo || eLogo.standard]}
        alt="Observodon logo mark"
        className={className}
        width={width}
        height={height}
        style={style}
      />
    </>
  );
};

export default Logo;
